function ChatMessage({ username, usertype, message, senttime, idx }) {
  const textColor = usertype === "userB" ? "var(--blue01)" : "var(--blue06)";
  
  return (
    <div
      className={`user ${usertype}`}
      key={idx}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "--chat-text-color": textColor,
      }}
    >
      <h5 style={{ display: "flex", justifyContent: "space-between" }}>
        <span style={{ color: textColor }}>
          {username}
        </span>
        <span style={{ color: textColor }}>
          {senttime}
        </span>
      </h5>

      <p
        style={{
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          color: textColor,
        }}
      >
        {message}
      </p>
    </div>
  );
}

export default ChatMessage;
